import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ForgotPasswordPage from "../../entities/ForgotPasswordPage";
import OtpVerificationPage from "../../entities/OtpVerificationPage";
import ResetPasswordPageWrapper from "../../entities/ResetPasswordPage/ResetPasswordPageWrapper";
import { useAlert } from "../../context/AlertContext";
import AuthService from "../../api/AuthService";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [otpTimer, setOtpTimer] = useState(60);

  const handleForgotPassword = async (data) => {
    try {
      setLoading(true);
      const result = await AuthService.forgotPassword(data);

      if (result?.success) {
        setEmail(data?.email?.value || data?.email);
        showAlert("A password reset link has been sent to your registered email address.", "success");
        navigate("/");
      } else {
        showAlert(
          result?.message || "Failed to send password reset link. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      showAlert(
        error?.message || "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };
  
  const handleResetPassword = async (data) => {
    try {
      setLoading(true);

      if (data.newPassword.value !== data.confirmPassword.value) {
        showAlert("Passwords do not match", "error");
        setLoading(false);
        return;
      }

      const result = await AuthService.resetPassword(data, resetToken);

      if (result?.success) {
        showAlert("Your password has been reset successfully.", "success");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        showAlert(
          result?.message || "Failed to reset password. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Reset password error:", error);
      showAlert(
        error?.message || "An error occurred. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  if (step === "reset") {
    return (
      <ResetPasswordPageWrapper
        handleResetPassword={handleResetPassword}
        loading={loading}
        onBack={() => {
          setStep("otp");
        }}
      />
    );
  }

  return (
    <ForgotPasswordPage
      handleForgotPassword={handleForgotPassword}
      loading={loading}
    />
  );
};

export default ForgotPassword;
